import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export { menusApi } from './menus'
export type { MenuItem, RolePermission, CreateMenuItemRequest, UpdateMenuItemRequest, Role } from './menus'

export const userProfileApi = {
  getCurrentUser: () =>
    api.get<ApiResponse<any>>('/users/me'),

  updateCurrentUser: (data: { username?: string; email?: string; phone?: string }) =>
    api.put<ApiResponse<any>>('/users/me', data),

  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    api.post<ApiResponse<any>>('/users/change-password', data),
}

export const rolesApi = {
  getAllRoles: () =>
    api.get<ApiResponse<{
      roles: any[];
      hierarchy: any;
      permissions: any;
    }>>('/roles'),

  getRolePermissions: (role: string) =>
    api.get<ApiResponse<{
      role: string;
      permissions: string[];
      display_name: string;
      description: string;
    }>>(`/roles/${role}/permissions`),

  getRoleHierarchy: () =>
    api.get<ApiResponse<{
      hierarchy: any[];
      levels: any;
    }>>('/roles/hierarchy'),

  getAllPermissions: () =>
    api.get<ApiResponse<{
      permissions: string[];
      permissionsByCategory: any;
      totalCount: number;
    }>>('/roles/permissions/all'),
}

export const sessionApi = {
  getUserSessions: () =>
    api.get<ApiResponse<{
      sessions: any[];
      currentSession: string;
    }>>('/sessions'),

  revokeSession: (sessionId: string) =>
    api.delete<ApiResponse<any>>(`/sessions/${sessionId}`),

  revokeOtherSessions: () =>
    api.delete<ApiResponse<{
      revokedCount: number;
    }>>('/sessions/others'),

  getSessionInfo: (sessionId: string) =>
    api.get<ApiResponse<any>>(`/sessions/${sessionId}`),
}

